import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  client_token: null, // Store token separately
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.user = action.payload.user;
      state.client_token = action.payload.token;

      // Store token in localStorage
      localStorage.setItem("client_token", action.payload.token);
    },
    logout: (state) => {
      state.user = null;
      state.client_token = null;

      // Remove token from localStorage on logout
      localStorage.removeItem("client_token");
    },
  },
});

export const { loginSuccess, logout } = userSlice.actions;
export default userSlice.reducer;
